



























































import {Vue, Component, Watch} from "vue-property-decorator";
import dataProxy from "../../../services/data-proxy.service";
import {OrganizacionaJedinica} from "../../../services/BackendProxies";
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";

@Component({})
export default class OrganizacionaSema extends mixins(ComponentBaseMixin) {

    orgSema = new OrganizacionaJedinica();
    data = [];
    url = '/images/home.png'

    async created() {
        this.data = await this.loadData(() => dataProxy.vratiOrganizacioneJedinice())();
        this.remapData();

    }

    onChange(node) {
        this.orgSema = node;
    }

    onMoved(node) {
        this.orgSema = node;
        this.sacuvajJedinicu();
    }

    novaJedinica() {
        this.orgSema = new OrganizacionaJedinica();
        (<HTMLElement>this.$refs.naziv).focus();
    }

    async sacuvajJedinicu() {
        const isValid = await (<any>this.$refs.form).validate();
        if (isValid) {
            this.data = await this.saveData(() => dataProxy.sacuvajOrganizacionuJedinicu(this.orgSema))();
            this.remapData();
            //  this.novaJedinica();
        }
    }

    async obrisiJedinicu() {
        const da = await this.confirmationNeeded('da li zelite da obrisete organizacionu strukturu')
        if (da) {
            this.data = await this.deleteData(() => dataProxy.obrisiOrganizacionuJedinicu(this.orgSema.id))();
            this.remapData();
            this.novaJedinica();
        }
    }

    private remapData() {
        this.data.map((obj) => {
            obj.icon = this.url;
            return obj;
        })
    }
}
